import {FlatList, Text, TextInput, View} from 'react-native';
import {useEffect, useState} from "react";
import { useIsFocused } from '@react-navigation/native';
import {useSelector} from "react-redux";
import OfferList from "../../components/OfferList/OfferList";
import Constants from 'expo-constants';

const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

export default function Favourites({navigation,route}) {
    let user = useSelector(state=>state.user.user)
    let appData = useSelector(state=>state.appData.appData)
    const isFocused = useIsFocused()
    useEffect(() => {
        if(!user.id && isFocused){
            navigation.navigate('SignIn',{
                ...route.params,
                merge: true,
                previousScreen: 'Favourites'
            })
        }
    },[isFocused, user])

    if(user.id && appData){
        let category = null
        if(route.params.category){
            category = route.params.category
        }
        return (
            <OfferList appData={appData}
                       navigation={navigation}
                       previousScreen={'Home'}
                       showSearch='true'
                       category={category}
                       user={user}
                       favourites={isFocused}
            />
        )
    } else {
        return (
            <></>
        )
    }
}
